/**
 * Cascading car search — home page
 *
 * Cascade structure: { brand: { family: { model: { year: route } } } }
 *
 * Behaviour on submit:
 *  - All 4 fields selected  → redirect to car's own route (direct car page)
 *  - Partial selection       → redirect to /cars?brand=X&family=Y&...
 */

export function initHeroSearch() {
  var dataEl = document.getElementById("homeCascadeData");
  var form   = document.getElementById("heroSearchForm");
  if (!dataEl || !form) return;

  var cascade = {};
  try {
    cascade = JSON.parse(dataEl.textContent || "{}");
  } catch (e) {
    return;
  }

  var selBrand  = document.getElementById("hs_brand");
  var selFamily = document.getElementById("hs_family");
  var selModel  = document.getElementById("hs_model");
  var selYear   = document.getElementById("hs_year");

  if (!selBrand || !selFamily || !selModel || !selYear) return;

  // ── Helpers ───────────────────────────────────────────────────────────────

  function resetSelect(sel, placeholder) {
    sel.innerHTML = '<option value="">' + placeholder + "</option>";
    sel.disabled = true;
    sel.value = "";
  }

  function fillSelect(sel, items, placeholder) {
    sel.innerHTML = '<option value="">' + placeholder + "</option>";
    items.forEach(function (val) {
      var opt = document.createElement("option");
      opt.value = val;
      opt.textContent = val;
      sel.appendChild(opt);
    });
    sel.disabled = items.length === 0;
  }

  function sortedAr(arr) {
    return arr.slice().sort(function (a, b) {
      return a.localeCompare(b, "ar");
    });
  }

  function sortedYears(arr) {
    return arr.slice().sort(function (a, b) {
      return Number(b) - Number(a);
    });
  }

  // ── Brand change ──────────────────────────────────────────────────────────
  selBrand.addEventListener("change", function () {
    var brand = this.value;

    resetSelect(selFamily, "— اختر العائلة —");
    resetSelect(selModel,  "— اختر الموديل —");
    resetSelect(selYear,   "— اختر السنة —");

    if (!brand || !cascade[brand]) return;

    var families = sortedAr(Object.keys(cascade[brand]));
    if (families.length > 0) {
      fillSelect(selFamily, families, "جميع العائلات");
    }
  });

  // ── Family change ─────────────────────────────────────────────────────────
  selFamily.addEventListener("change", function () {
    var brand  = selBrand.value;
    var family = this.value;

    resetSelect(selModel, "— اختر الموديل —");
    resetSelect(selYear,  "— اختر السنة —");

    if (!brand || !family) return;
    if (!cascade[brand] || !cascade[brand][family]) return;

    var models = sortedAr(Object.keys(cascade[brand][family]));
    if (models.length > 0) {
      fillSelect(selModel, models, "جميع الموديلات");
    }
  });

  // ── Model change ──────────────────────────────────────────────────────────
  selModel.addEventListener("change", function () {
    var brand  = selBrand.value;
    var family = selFamily.value;
    var model  = this.value;

    resetSelect(selYear, "— اختر السنة —");

    if (!brand || !family || !model) return;

    var yearMap = cascade[brand] &&
                  cascade[brand][family] &&
                  cascade[brand][family][model];
    if (!yearMap) return;

    var years = sortedYears(Object.keys(yearMap));
    if (years.length > 0) {
      fillSelect(selYear, years, "جميع السنوات");
    }
  });

  // ── Form submit ───────────────────────────────────────────────────────────
  form.addEventListener("submit", function (e) {
    e.preventDefault();

    var brand  = selBrand.value.trim();
    var family = selFamily.value.trim();
    var model  = selModel.value.trim();
    var year   = selYear.value.trim();

    // Must at least select a brand
    if (!brand) {
      selBrand.style.outline = "2px solid rgba(220,38,38,.7)";
      setTimeout(function () { selBrand.style.outline = ""; }, 1800);
      return;
    }

    // All 4 selected → go directly to the specific car page
    if (brand && family && model && year) {
      var route = cascade[brand] &&
                  cascade[brand][family] &&
                  cascade[brand][family][model] &&
                  cascade[brand][family][model][year];
      if (route) {
        window.location.href = route;
        return;
      }
    }

    // Partial selection → go to cars listing with filters
    var params = new URLSearchParams();
    params.set("brand", brand);
    if (family) params.set("family", family);
    if (model)  params.set("model",  model);
    if (year)   params.set("year",   year);

    window.location.href = "/cars?" + params.toString();
  });
}
